import Vue from 'vue';
import VueRouter from 'vue-router';
import routerConstants from '@/const/routerConstants';
import pageViews from './page';
import settingPageViews from './settingPage';
import appPageViews from './appPage';
import { callApp } from '@/utils/app/callApp.js';
import { checkAuth } from '@/utils/auth/authUtil';
//import { loadLocale } from '@/plugins/locales'; //다국어 ejkim

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history', // URL의 #이 제거 된다.
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes: [
    {
      path: '/',
      redirect: '/login',
    },
    // home
    {
      name: routerConstants.Main,
      path: '/main',
      meta: { bottomNav: true },
      component: () => import('@/views/home/MainView.vue'),
    },

    {
      name: 'appResponse',
      path: '/appResponse/:type',
      component: () => import('@/views/home/AppResponse.vue'),
    },

    {
      name: routerConstants.Calendar,
      path: '/calendar',
      meta: { bottomNav: true },
      component: () => import('@/views/etc/CalendarView.vue'),
    },
    {
      name: routerConstants.MemberSearch,
      path: '/memberSearch',
      meta: { bottomNav: true },
      component: () => import('@/views/etc/MemberSearchView.vue'),
    },
    {
      name: routerConstants.AllMenu,
      path: '/allMenu',
      meta: { bottomNav: true },
      component: () => import('@/views/etc/AllMenuView.vue'),
    },
    {
      path: '/setting',
      component: () => import('@/views/home/SettingPageView.vue'),
      children: settingPageViews,
    },
    {
      name: routerConstants.Page,
      path: '/page',
      meta: { bottomNav: true },
      component: () => import('@/views/home/PageView.vue'),
      children: pageViews,
    },
    {
      name: routerConstants.AppPage,
      path: '/appPage',
      component: () => import('@/views/home/AppPageView.vue'),
      children: appPageViews,
    },

    // error
    {
      name: routerConstants.Error,
      path: '/error',
      component: () => import('@/views/home/ErrorView.vue'),
      props: true,
    },

    // policy consent (앱최초 약관동의)
    {
      name: routerConstants.PolicyConsent,
      path: '/policyConsent',
      component: () => import('@/views/home/policy/PolicyConsentView.vue'),
    },
    {
      name: routerConstants.PolicyConsentService,
      path: '/policyConsent/service',
      component: () => import('@/views/home/policy/ServiceView.vue'),
    },
    {
      name: routerConstants.PolicyConsentPrivacy,
      path: '/policyConsent/privacy',
      component: () => import('@/views/home/policy/PrivacyView.vue'),
    },

    // login
    {
      name: routerConstants.Login,
      path: '/login',
      component: () => import('@/views/auth/LoginView.vue'),
    },

    // login

    {
      name: 'rdTest',
      path: '/rdTest',
      component: () => import('@/views/test/rdTest.vue'),
    },
    //제증명신청 및 뷰어
    {
      path: '/certAppViewer',
      component: () => import('@/views/test/CertAppViewer.vue'),
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  //다국어 ejkim
  //await loadLocale();

  // /* 권한 체크 */
  if (
    process.env.NODE_ENV === 'production' &&
    to.name !== 'appResponse' &&
    to.name !== routerConstants.Login &&
    to.name !== routerConstants.PolicyConsent &&
    to.name !== routerConstants.PolicyConsentService &&
    to.name !== routerConstants.PolicyConsentPrivacy &&
    to.name !== routerConstants.Error
  ) {
    const result = checkAuth();
    if (!result) {
      return false;
    }
  }

  /* 앱 접근시 */
  //  로그인화면에서는 제외
  const userAgent = window.navigator.userAgent.toLowerCase();
  if (
    userAgent.indexOf('iphone') > -1 ||
    userAgent.indexOf('ipad') > -1 ||
    userAgent.indexOf('android') > -1
  ) {
    // 급여페이지 접근 시 비밀번호 입력 호출
    if (to.path.indexOf('/paySta') !== -1) {
      callApp.activateSecureScreen(to.path);
    } else {
      callApp.inactivateSecureScreen(to.path);
    }
  }

  next();
  //await loadLocale();
});

router.onError(error => {
  console.error('>>> router onError :: ', error);
  const domainUrl = `${window.location.protocol}//${window.location.host}${process.env.VUE_APP_FULL_BASE_URL}`;

  // ChunkLoadError
  if (error.name === 'ChunkLoadError') {
    // alert('[error] ChunkLoadError');
    window.location.href = `${domainUrl}/main`; // 메인으로 이동
  } else {
    window.location.href = `${domainUrl}/error`; // 에러페이지로 이동
  }
});

export default router;
